export default __webpack_public_path__ + "static/media/Banner3.725f15f3.webp";